// extracted by mini-css-extract-plugin
export default {"appContainer":"MainLayout_appContainer__xoiaI","main":"MainLayout_main__iAJtu","displaySection":"MainLayout_displaySection__zF5RW"};